import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=53f2c365&scoped=true&"
import script from "./AboutModal.vue?vue&type=script&lang=ts&"
export * from "./AboutModal.vue?vue&type=script&lang=ts&"
import style0 from "./AboutModal.vue?vue&type=style&index=0&id=53f2c365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2c365",
  null
  
)

export default component.exports